import Constants from 'expo-constants';

export const APP_RELEASE =
  process.env['EXPO_PUBLIC_RELEASE'] ??
  process.env['CF_PAGES_COMMIT_SHA'] ??
  process.env['EAS_BUILD_GIT_COMMIT_HASH'] ??
  Constants.expoConfig?.version ??
  'unknown';
